import React, {useEffect,useRef, useState} from "react";
import {  useParams } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Typography from '@material-ui/core/Typography';
import '@fontsource/roboto';
import hashtag from '../media/instruction/hashtag.gif';
import vote from '../media/instruction/vote.gif';
import updown from '../media/instruction/updown.gif';
import hashtagExample from '../media/instruction/hashtag-example.png';
import flag from '../media/instruction/flag.png';
import reason from '../media/instruction/flag-reason.png';
import $ from 'jquery';


const useStyles = makeStyles((theme) => ({
  img:{
    maxWidth: '80%'
  },
  li:{
    paddingBottom: '10px'
  }
}));


export default function Instruction(props){
  let { postno, condition } = useParams();
  const classes=useStyles();
  const [numPage, setNumPage]=useState(0);
  const token = localStorage.getItem('token');
  const username = localStorage.getItem('username');

  const handleStart=event =>{
    event.preventDefault();
    const self=this;
    $.ajax({
      url:'/api/record-post-start/',
      method: 'POST',
      data: {'condition': condition, 'post_no': postno, 'username': username},
      success: function(res){
          window.location='/post/'+postno+'/'+condition+'/';
      },
      error: function(err){
          console.log('error!')
      },
        });
      };
    

      return (
        <div style={{padding: '40px', backgroundColor: 'white', paddingBottom: '100px'}}>
          {condition==='binary'? 
          <div>
            <Typography variant='h5' className={classes.li}>
             How To Use 
            </Typography>

            <div style={{textAlign:'justify', marginBottom: '20px'}}>
              <Typography variant='body1'>Below we explain how to use this system. Please read below instruction thorougyly.</Typography>
              <Typography variant='body1' component={'ul'}>
                <li className={classes.li}>
                In this task, you are going to read a post and comments from an online discussion forum.
                </li>
                <li className={classes.li}>
                As in common discussion platform, you can write a comment to the post or reply to others' comments, or vote or react to others' comments.
                </li >
                <li className={classes.li}>
                  To upvote or downvote a comment, click 'Up' or 'Down' button on the comment. </li >
                  <img className={classes.img} id='img-updown' alt='gif on how to add hashtag buttons' src={updown} />
              </Typography>
            </div>
            <div>
            <Typography variant={'body1'}>
                  <li>
                    When you are done, click 'FINISH' button on the bottom right. Note that you are required you spend more than 2 minutes to read, comment, reply, and react.   
                    </li>                 
                </Typography>
              </div>
           <div>
           <Typography variant={'body1'}>
             If you are ready to start, click 'START' button! 
           </Typography>
         </div>
           <div style={{float:'right', marginRight: '30px'}}>
            <form onSubmit={handleStart} >
            <Button variant='contained' color='primary'  className={classes.root} type="submit">
              Start
            </Button>
          </form>
          </div>
          </div>
          : null}


          {condition==='text'?  
          <div>
           <Typography variant='h5' className={classes.li}>
             How To Use 
            </Typography>
            {numPage===0? 
              <div style={{textAlign:'justify', marginBottom: '20px'}}>
                <Typography variant='body1'>Below we explain how to use this system. Please read below instruction thorougyly.</Typography>
                <Typography variant='body1' component={'ul'}>
                  <li className={classes.li}>
                  In this task, you are going to read a post and comments from an online discussion forum.
                  </li>
                  <li className={classes.li}>
                  As in common discussion platform, you can write a comment to the post or reply to others' comments, or vote or react to others' comments.
                  </li >
                  <li className={classes.li}> However, in this task, the way of 'voting' or 'reaction' is a bit different. You are going to vote or react to each comment through <span style={{color: "blue"}}>text</span> buttons. </li>
                  <img className={classes.img} id='img-hashtag-example' alt='gif on how to add hashtag buttons' src={hashtagExample} style={{border:'1px solid lightgrey'}}/>
                </Typography>
                </div> : null}
            {numPage===1? 
              <div style={{textAlign:'justify', marginBottom: '20px'}}>
              <Typography variant='body1' component={'ul'}>
                <li>You can <span style={{color: 'blue'}}> create text buttons </span>that describe what you like (upvote) or dislike (downvote) about the comments.
                  <ul>
                    <li>
                      The text should contain more than 2 characters and cannot exceed 20 characters. 
                    </li>
                    <li>
                      The text cannot include white space.
                    </li>
                    <li>
                      You can generate multiple text buttons on each comment. 
                    </li>
                    <img className={classes.img} id='img-hashtag' alt='gif on how to add hashtag buttons' src={hashtag} />
                    </ul>
                    </li>
                  <li>
                    Or you can <span style={{color: 'blue'}}> click text buttons </span> generated by others to express your opinion. 
                    <ul>
                    <li>
                      You can vote on multiple buttons on each comment.
                    </li>
                    <img className={classes.img} id='img-vote' alt='gif on how to vote on hashtag buttons' src={vote} />
                    </ul>
                  </li>
              </Typography>
            </div> : null}
            {numPage===2? 
              <div style={{textAlign:'justify', marginBottom: '20px'}}>
              <Typography variant='body1' component={'ul'}>
                <li>Please  <span style={{color: 'blue'}}>DO</span>
                  <ul>
                    <li>
                      Use unit of word or short phrases as text label to specify what you like/dislike about the comment. 
                    </li>
                    <li>
                      Use labels that evaluate certain aspects of the comments. <span style={{color: 'blue'}}> Logical, TooEmotional, StrongArgument, Misinformation </span> are good examples.
                    </li>
                  </ul>
                </li>
                <li>Please <span style={{color: 'red'}}>DON'T</span>
                  <ul>
                    <li>
                      Do not use bad words. Text button or comments with bad words can be removed  can be removed by researchers without any pre/post notificaiton.
                    </li>
                    <li>
                      Do not make long sentences as a text button. Long sentences should be left in a form of comment or reply. 
                    </li>
                  </ul>
                </li>
              </Typography>
            </div> : null}
            {numPage===3? 
              <div style={{textAlign:'justify', marginBottom: '20px'}}>
              <Typography variant='body1' component={'ul'}>
                <li>Please  <span style={{color: 'blue'}}>DO</span>
                  <ul>
                    <li>
                    You can flag a hashtag if it is insulting or irrelevant. To flag, right-click the hahstag and click 'FLAG THIS BUTTON' and submit it with a reason.                     
                    </li>
                    <div style={{textAlign:'center'}}>
                    <img style={{width:'200px'}} id='img-vote' alt='gif on how to vote on hashtag buttons' src={flag} />
                    <img style={{width:'200px'}} id='img-vote' alt='gif on how to vote on hashtag buttons' src={reason} />
                    </div>
                  </ul>
                </li>
              </Typography>
            </div> : null}
            {numPage===4?
              <div style={{textAlign:'justify', marginBottom: '20px'}}>
                <div>
                <Typography variant={'body1'}>
                  <li>
                    When you are done, click 'FINISH' button on the bottom right. Note that you are required you spend more than 2 minutes to read, comment, reply, and react.   
                    </li>                 
                </Typography>
                  <Typography variant={'body1'}>
                    <li>
                    If you are ready to start, click 'START' button! 
                    </li>
                  </Typography>
                </div>
                  <div style={{float:'right', marginRight: '30px'}}>
                  <form onSubmit={handleStart} >
                  <Button variant='contained' color='primary'  className={classes.root} type="submit">
                  Start
                  </Button>
                </form>
              </div>
              </div>: null
            }
            <div style={{textAlign: 'center'}}>
            <ButtonGroup color="primary" variant="contained" aria-label="outlined primary button group">
              <Button onClick={()=>setNumPage(numPage-1)} disabled={numPage===0}>Prev</Button>
              <Button onClick={()=>setNumPage(numPage+1)} disabled={numPage===4}>Next</Button>
            </ButtonGroup>
            </div>
        </div> : null}
        </div>
        );
  }